/**
 * Mixin that handles map interactions and animations.
 *
 * Responsibilities:
 * - Handling marker selection and info overlay
 * - Managing map zoom and pan animations
 *
 * The mixin expects the following to be available in the component:
 * - this.map: Google Maps instance
 * - this.showMarkerOverlay: Boolean for overlay visibility
 * - this.selectedLocation: Object for currently selected location
 * - this.currentMarker: Currently active marker
 * - changeMarker method from marker-handler mixin
 */
export default {
  methods: {
    onSelectMarker(map, marker) {
      if (this.$route && this.$route.query.property !== marker.locationData.Id) {
        const queryParams = { ...this.$route.query }
        queryParams.property = marker.locationData.Id
        this.$router.push({ query: queryParams })
      }
      this.showMarkerOverlay = false
      this.currentMarker = marker
      this.selectedLocation = marker.locationData
      map.panTo(marker.position)
      map.setCenter(marker.position)
      this.smoothZoom(map, marker, 6, map.getZoom())
    },

    smoothZoom(map, marker, max, cnt) {
      if (cnt > max) {
        this.changeMarker(marker, 'active')
        this.showMarkerOverlay = true
      } else {
        const z = google.maps.event.addListener(map, 'zoom_changed', () => {
          google.maps.event.removeListener(z)
          this.smoothZoom(map, marker, max, cnt + 1)
        })
        setTimeout(() => {
          map.setZoom(cnt)
          this.changeMarker(marker, 'active')
          this.showMarkerOverlay = true
        }, 200)
      }
    },

    resetZoom() {
      this.map.setZoom(Number(this.options.ZoomLevel))
      this.map.setCenter({
        lat: Number(this.options.Latitude),
        lng: Number(this.options.Longitude),
      })
    },

    smoothZoomToLatLng(map, level, latLng) {
      map.panTo(latLng)
      map.setZoom(Number(level))
      map.setCenter(latLng)
    },

    closeMapContent() {
      if (this.$route && this.$route.query.property) {
        const queryParams = { ...this.$route.query }
        delete queryParams.property
        this.$router.push({ query: queryParams })
      }
      this.showMarkerOverlay = false
      if (this.selectedLocation) {
        this.changeMarker(this.currentMarker, 'default')
        this.selectedLocation = {}
      }
    },
  }
}
